import React from "react";

const LegalPerson = ({ legalPerson }) => {
    if (!legalPerson) {
        return null;
    }
    return (
        <>
            <div className="show-bid__main-info--title">Юр. лицо</div>
            <div className="show-bid__main-info--value" data-test-id="legal-person">
                {legalPerson.name}
            </div>
        </>
    );
};

export default LegalPerson;
